import { Component, input } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import {ComponentEntity} from "../../../entities/component-entity";
import {PositionDirective} from "../../../directives/position.directive";
import {ClickComponentDirective} from "../../../directives/click-component.directive";
import {defaultComponentEntity} from "../../../commons/defaults-components";

@Component({
  selector: 'lib-image',
  standalone: true,
  imports: [
    CommonModule,
    NgOptimizedImage,
    PositionDirective,
    ClickComponentDirective,
  ],
  templateUrl: './image.component.html',
  styleUrl: './image.component.css',
})
export class ImageComponent {

  component = input<ComponentEntity>(defaultComponentEntity());

}
